 import fetch from './fetch.js'

 let url = ''
 if (process.env.NODE_ENV == 'development') {
     url = 'service'
 } else {
    //  url = "http://m.psypyp.com/psypyp"
    url = "/psypyp"
 }
 /**
  * 获取省市区
  * @param {*} body 
  */
 export const getRegion = (body) => {
         return fetch.get(`${url}/region/getRegionByParent`, body)
     }
     /**
      * 获取筛选的title
      * @param {*} body 
      */
 export const getDictList = () => {
         return fetch.get(`${url}/dict/getDictList`)
     }
     /**
      * 获取咨询title下面的具体内容
      * @param {*} body 
      */
 export const getDictDetailList = (body) => {
         return fetch.get(`${url}/dict/getDictDetailList`, body)
     }
     /**
      * 筛选list或者关键词搜索出list
      * @param {*} body 
      */
 export const getList = (body) => {
         return fetch.post(`${url}/consultant/info/list`, body)
     }
     /**
      * 获取列表详情
      * @param {*} id 
      */
 export const getDetail = (body) => {
         return fetch.get(`${url}/consultant/info/detail`, body)
     }
     /**
      * 获取分享
      * @param {*} 
      */
 export const shareWx = (body) => {
     return fetch.get(`${url}/wechat/config`, body)
 }


// WEBPACK FOOTER //
// ./src/service/api.js